const navListData = [
  { id: 1, link: "#", name: "home", active: true },
  { id: 2, link: "#schedule", name: "schedule", active: false },
  { id: 3, link: "#trend", name: "trend", active: false },
  { id: 4, link: "#blogs", name: "blog", active: false },
];
export default navListData;
